(function () {
  var SWIPER_SELECTOR =
    '.swiper,.js-slider-logos,.js-slider-logos-slow,.js-media-list,.js-media-sublist,.js-popup-slider,.js-recommendation-swiper';
  var bootScript = document.currentScript;
  var swiperSrc = bootScript && bootScript.dataset.swiperSrc;
  var swiperCss = bootScript && bootScript.dataset.swiperCss;

  function needsSwiper() {
    return Boolean(document.querySelector(SWIPER_SELECTOR));
  }

  function loadStylesheet(href) {
    return new Promise(function (resolve, reject) {
      if (!href) {
        resolve();
        return;
      }
      var existing = document.querySelector('link[data-swiper-boot-href="' + href + '"]');
      if (existing) {
        resolve();
        return;
      }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.swiperBootHref = href;
      link.addEventListener('load', function () {
        resolve();
      }, { once: true });
      link.addEventListener('error', reject, { once: true });
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-swiper-boot-src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset.swiperBootSrc = src;
      script.addEventListener(
        'load',
        function () {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  window.themeSwiperReady = new Promise(function (resolve, reject) {
    function boot() {
      if (!needsSwiper()) {
        resolve(null);
        return;
      }

      if (!swiperSrc) {
        reject(new Error('Missing swiper src'));
        return;
      }

      loadStylesheet(swiperCss)
        .then(function () {
          return loadScript(swiperSrc);
        })
        .then(function () {
          resolve(window.Swiper || null);
        })
        .catch(reject);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  });
})();
